module.exports = __webpack_public_path__ + "static/media/menu.ddf1421c.png";